import cn from 'classnames';
import { selectChannel } from 'components/Header/themes/BGH/selector';
import { Section } from 'components/Section';
import { isArredoChannel } from 'components/Shared/channel';
import { useSelector } from 'react-redux';
import { ContactSection } from './contactSection';
import { FooterLinks } from './footerLinks';
import styles from './styles.scss';

export const Footer = () => {
  const channel = useSelector(selectChannel);
  const showBottomSection = isArredoChannel(channel) === false;

  return (
    <footer className={styles.spacer}>
      <Section className={cn(styles.footerSection, styles.footer)}>
        <ContactSection />
        <FooterLinks />
      </Section>
      {showBottomSection && <div className={styles.bottomSection} />}
    </footer>
  );
};
